import { memoizeFunction, mergeStyles } from "@fluentui/react";
// Constants
import { Colors } from "@ms/uno-constants/lib/local/Colors";
// Models
import { PlannerTheme } from "@ms/uno-constants/lib/local/ThemeConstants";
export const getStyles = (theme)=>{
    return {
        root: {
            width: "100%",
            maxWidth: 694,
            height: 78,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            paddingTop: "46px"
        },
        topRow: {
            display: "flex",
            alignItems: "center"
        },
        icon: {
            width: 24,
            height: 24,
            marginRight: 14
        },
        textWrapper: {
            display: "flex",
            justifyContent: "space-between",
            width: "100%"
        },
        primaryText: {
            fontSize: "13.3px",
            fontWeight: 400,
            color: theme.name === PlannerTheme.HighContrast || theme.name === PlannerTheme.Dark || theme.name === PlannerTheme.Dark ? Colors.White : Colors.Black
        },
        secondaryText: {
            fontSize: "12px",
            fontWeight: 400,
            color: theme.palette.neutralSecondary
        },
        feedbackWrapper: {
            marginRight: 367,
            selectors: {
                span: {
                    fontSize: "11px",
                    backgroundColor: "transparent"
                }
            }
        }
    };
};
export const getClassNames = memoizeFunction((styles)=>({
        root: mergeStyles("AIGeneratedTaskSection", styles.root),
        topRow: mergeStyles("AIGeneratedTaskSection-topRow", styles.topRow),
        icon: mergeStyles("AIGeneratedTaskSection-icon", styles.icon),
        textWrapper: mergeStyles("AIGeneratedTaskSection-textWrapper", styles.textWrapper),
        primaryText: mergeStyles("AIGeneratedTaskSection-primaryText", styles.primaryText),
        secondaryText: mergeStyles("AIGeneratedTaskSection-secondaryText", styles.secondaryText),
        feedbackWrapper: mergeStyles("AIGeneratedTaskSection-feedbackWrapper", styles.feedbackWrapper)
    }));
